import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import "../styles/Contact.css";

export default function Contact() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);

  /*  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "";
    }; // cleanup
  }, []);
  //make so no scrolling occurs for this page */

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const q = query(
        collection(db, "mailingList"),
        where("email", "==", email),
      );
      const existing = await getDocs(q);

      if (!existing.empty) {
        setStatus("duplicate");
        return;
      }

      await addDoc(collection(db, "mailingList"), {
        email: email,
        joinedAt: new Date(),
      });
      setStatus("success");
      setEmail("");
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="contact">
      {status === "success" ? (
        <p>
          you're on the list. <br /> thank you for signing up &lt; 3
        </p>
      ) : (
        <div>
          <h2 id="join-ask">Join our mailing list</h2>
          <form onSubmit={handleSubmit}>
            <input
              id="email-input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={status === "loading"}>
              {status === "loading" ? "Joining..." : "Join"}
            </button>
            <div id="error-container">
              {status === "duplicate" && (
                <p className="error">you're already signed up ... silly</p>
              )}
              {status === "error" && (
                <p className="error">something went wrong, try again.</p>
              )}
            </div>
          </form>
        </div>
      )}
    </section>
  );
}
